import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { app } from './firebase';

const storage = getStorage(app);

/**
 * Sube una imagen a Firebase Storage (versión web)
 * @param file - Archivo File del input
 * @param path - Ruta en Storage donde se guardará (ej: "users/profile.jpg")
 * @returns URL de descarga de la imagen subida
 */
export async function uploadImage(file: File, path: string): Promise<string> {
  try {
    // Crear referencia en Storage
    const storageRef = ref(storage, path);

    // Subir el archivo
    await uploadBytes(storageRef, file);

    // Obtener URL de descarga
    const downloadURL = await getDownloadURL(storageRef);

    return downloadURL;
  } catch (error) {
    console.error('Error al subir imagen:', error);
    throw new Error('Error al subir la imagen. Por favor, intenta nuevamente.');
  }
}

/**
 * Genera un nombre único para la imagen del usuario
 * @param userId - ID del usuario (opcional, si no existe se genera un UUID temporal)
 * @returns Nombre del archivo con timestamp
 */
export function generateUserImagePath(userId?: string): string {
  const timestamp = Date.now();
  const randomId = userId || `temp-${Math.random().toString(36).substring(2, 9)}`;
  return `users/${randomId}/profile-${timestamp}.jpg`;
}

/**
 * Genera un nombre único para la imagen de banner promocional
 * @param bannerId - ID del banner (opcional, si no existe se genera un UUID temporal)
 * @returns Nombre del archivo con timestamp
 */
export function generatePromotionalBannerPath(bannerId?: string): string {
  const timestamp = Date.now();
  const randomId = bannerId || `temp-${Math.random().toString(36).substring(2, 9)}`;
  return `promotional-banners/${randomId}/banner-${timestamp}.jpg`;
}

